// extracted by mini-css-extract-plugin
export var dataCell = "_oe-2";
export var dataRow = "_oe-0";
export var headerRow = "_oe-1";